/* time format const */
const TIME_FORMAT_CONST = {
  DAY_MONTH_YEAR_FORMAT: 'DD-MM-YYYY',
  FULL_TIME_MOVIE_FORMAT: 'DD-MM-YYYY ~ hh:mm',
  ONLY_YEAR_FORMAT: 'YYYY',
};

export { TIME_FORMAT_CONST };
